// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
ul[data-v-510f157d] {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 4em;
  margin-right: 2em;
  padding: 0.5em;
}
ul[data-v-510f157d]:hover {
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  border-radius: 3px;
  background-color: rgba(161, 161, 161, 0.1);
}
.close-button[data-v-510f157d] {
  color: white;
  position: fixed;
  right: 0.5em;
  text-align: center;
  line-height: 1.2em;
  border-radius: 0.6em;
  height: 1.2em;
  width: 1.2em;
  cursor: pointer;
}
.close-button[data-v-510f157d]:hover {
  background-color: white;
  color: lightgray;
}
li[data-v-510f157d] {
  display: inline-block;
  box-shadow: 0px 0px 5px lightgray;
  cursor: pointer;
  background-color: #eff1f3;
  border-radius: 0.2rem;
  padding: 0.4rem;
  font-size: 0.5em;
  width: 30%;
  margin: 0 1em;
  color: #4b647d;
}
li[data-v-510f157d]:hover {
  background-color: #e0e4e8;
}
.prompt-number[data-v-510f157d] {
  font-size: 2em;
  color: #c1c9d1;
  display: block;
  position: relative;
  top: -1rem;
  right: 1rem;
  height: 1.5rem;
  width: 1.5rem;
  text-align: center;
  border-radius: 50%;
  background-color: #e0e4e8;
}
p[data-v-510f157d] {
  margin-bottom: 0;
  margin-top: -1.5rem;
  position: relative;
  font-size: 1.7em;
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./src/components/PromptExamples.vue"],"names":[],"mappings":";AA2CA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["<script setup lang=\"ts\">\nimport { store } from '@/store';\n\nconst props = defineProps({\n  userInputting: Boolean\n});\n\nconst emit = defineEmits(['onSelectPrompt']);\n\ndocument.addEventListener('keydown', function (event) {\n  const key = Number(event.key);\n  if (\n    !props.userInputting &&\n    event.key != ' ' &&\n    !isNaN(key) &&\n    key <= store.getExamplePrompts().length\n  ) {\n    selectPrompt(key - 1);\n  }\n});\n\nfunction selectPrompt(index: number) {\n  const prompt = store.getExamplePrompts()[index];\n\n  window.setTimeout(() => emit('onSelectPrompt', prompt), 50);\n}\n</script>\n\n<template>\n  <ul>\n    <li v-for=\"(prompt, i) of store.getExamplePrompts()\" @click=\"selectPrompt(i)\">\n      <span class=\"prompt-number\">\n        {{ i + 1 }}\n      </span>\n      <p>\n        {{ prompt[store.lang] }}\n      </p>\n    </li>\n    <span class=\"close-button\" @click=\"store.setExamplePromptsVisible(false)\">×</span>\n  </ul>\n</template>\n\n<style scoped>\nul {\n  list-style-type: none;\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  bottom: 4em;\n  margin-right: 2em;\n  padding: 0.5em;\n}\nul:hover {\n  backdrop-filter: blur(3px);\n  -webkit-backdrop-filter: blur(3px);\n  border-radius: 3px;\n  background-color: rgba(161, 161, 161, 0.1);\n}\n.close-button {\n  color: white;\n  position: fixed;\n  right: 0.5em;\n  text-align: center;\n  line-height: 1.2em;\n  border-radius: 0.6em;\n  height: 1.2em;\n  width: 1.2em;\n  cursor: pointer;\n}\n.close-button:hover {\n  background-color: white;\n  color: lightgray;\n}\nli {\n  display: inline-block;\n  box-shadow: 0px 0px 5px lightgray;\n  cursor: pointer;\n  background-color: #eff1f3;\n  border-radius: 0.2rem;\n  padding: 0.4rem;\n  font-size: 0.5em;\n  width: 30%;\n  margin: 0 1em;\n  color: #4b647d;\n}\nli:hover {\n  background-color: #e0e4e8;\n}\n.prompt-number {\n  font-size: 2em;\n  color: #c1c9d1;\n  display: block;\n  position: relative;\n  top: -1rem;\n  right: 1rem;\n  height: 1.5rem;\n  width: 1.5rem;\n  text-align: center;\n  border-radius: 50%;\n  background-color: #e0e4e8;\n}\np {\n  margin-bottom: 0;\n  margin-top: -1.5rem;\n  position: relative;\n  font-size: 1.7em;\n  z-index: 10;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
